<template>
    <section class="contract-online-sign-flow-content-first-config scroll-color">
        <div class="configurations">
            <span class="text-config">1 - Configurações</span>
            <span class="define-signature">Faça as definições para assinatura digital do contrato</span>
        </div>

        <div class="flow-signature">
            <ui-input
                v-model="form.data.name"
                :maxlength="45"
                label="Informe o nome do fluxo de assinatura:"
                placeholder="Ex. Assinatura Contrato"
                required
            />
        </div>

        <div class="envelope-status">
            <div class="standard-invisible-signature">
                <ui-radio
                    name="sig-type"
                    label="Assinatura padrão"
                    value="8"
                    inline
                    required
                    @input="typeHandler"
                />

                <ui-radio
                    name="sig-type"
                    label="Assinatura invisível"
                    value="16"
                    inline
                    required
                    @input="typeHandler"
                />
            </div>

            <div class="footer-button">
                <ui-button
                    :disabled="!canSubmit"
                    design="mw-200 success lg"
                    @click="next"
                >
                    Avançar
                </ui-button>
            </div>
        </div>
    </section>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import { uiInput, uiRadio } from '@/components/ui/form'

    import { mapActions } from 'vuex'

	export default {
		name: 'ui-online-sign-contract-sign-flow-config',

		components: {
			uiButton,
            uiInput,
            uiRadio
		},

        data() {
            return {
                form: {
                    data: {
                        name: '',
                        type: ''
                    }
                }
            }
        },

		computed: {
            /**
             * Computed property que define se as configurações podem ser salvas
             */
			canSubmit() {
				return this.form.data.name && this.form.data.type
			},
		},

        methods: {
            ...mapActions('digitalSignatureStore', ['setEnvelope']),
            /**
			 * Event handler que trata o evento de quando o tipo do Fluxo de Assinatura
			 * é selecionado
			 */
			typeHandler(event) {
				this.form.data.type = event || ''
			},
            /**
             * Salva as configurações e passa para a próxima etapa
             */
			next() {
                this.setEnvelope(this.form.data)
                this.$emit('next')
            }
        }
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>